// Judgment type
export const is = {
  array(data: unknown): boolean {
    return Array.isArray(data);
  },
  object(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Object]';
  },
  map(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Map]';
  },
  func(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Function]';
  },
  file(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object File]';
  },
  fileList(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object FileList]';
  },
  empty(data: unknown): boolean {
    return (
      typeof data === 'undefined' ||
      Object.prototype.toString.call(data) === '[object Null]'
    );
  },
  emptyObject(data: { [key: string]: unknown }): boolean {
    return Object.keys(data).length === 0;
  },
};

export function parseQueryString() {
  const search = window.location.search;
  if (!search) return {};
  const obj: Record<string, string> = {};
  const paraString = search
    .substring(search.indexOf('?') + 1, search.length)
    .split('&');
  for (const i in paraString) {
    const keyvalue = paraString[i].split('=');
    obj[keyvalue[0]] = keyvalue[1];
  }
  return obj;
}

export function uniqueKey() {
  return Date.now().toString(32).slice(2);
}
